// extracted by mini-css-extract-plugin
export default {"alertWrapper":"styles_alertWrapper__0AIBd"};